import { Component } from '@angular/core';
import { NavController, NavParams,LoadingController } from 'ionic-angular';
import {DriverServiceProvider} from '../../../../providers/dvm/driver-service';


@Component({
  selector: 'page-list',
  templateUrl: 'index.html',
  providers: [DriverServiceProvider]
})
export class DriverListPage {
 header_data:any;

  icons: string[];
  items: Array<{title: string, note: string, icon: string}>;

  public drivers_list: any;

  constructor(public navCtrl: NavController, public navParams: NavParams,public driverService: DriverServiceProvider,public loadingCtrl: LoadingController) {
    this.header_data={ismenu:true,ishome:false,title:"FODEL Driver Manager"};
    this.loadWaybills();
  }

  
      loadWaybills(){



  let loader = this.loadingCtrl.create({
      content: "Please wait..."
    });
    loader.present();



        this.driverService.load_driver_list()
        .then(data => {
          this.drivers_list = data;
        });
        loader.dismiss();
      }
  


    openDriverDetails(a) {
           console.log('Driver Page Loaded');
  console.log(a);
    this.navCtrl.push('DriverDetailPage',a);
  }




    openDriverAreaPage(a) {
           console.log('Area Page Loaded');
  console.log(a);
    this.navCtrl.push('AreaListPage',a);
  }


}



// WEBPACK FOOTER //
// ./src/pages/dvm/driver/list/index.ts